import { render, staticRenderFns } from "./TopicMediaPreview.vue?vue&type=template&id=417f498a"
import script from "./TopicMediaPreview.vue?vue&type=script&lang=js"
export * from "./TopicMediaPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports